import { TqcWorkStandardDto } from "src/dtos/tqcWorkStandard/tqcWorkStandardDto";
import { ItemDto } from "src/types/base";

export interface MST3020_R01Dto {
	itemHeaderDto: MST3020_R01HeaderDto;
	tqcWorkStandardDetailDtoList: MST3020_R01DetailDto[];
}

//작업표준 등록 헤더
export interface MST3020_R01HeaderDto extends ItemDto {

}

export const defaultMST3020_R01HeaderDto: MST3020_R01HeaderDto = {
	valueIndex: 0,
	orderIndex: 0,
	orderIndexSeq: 0,

	itemCd: '',
	itemNm: '',
	modelNo: '',
	itemSpec: '',
	itemUnit: '',
	brandCd: '',
	itemGroup: '',
	itemAccount: '',
	stockQty: 0,
	itemCost: 0,
	workCost: 0,
	stockAmount: 0,
	locationCd: '',
	locationNm: '',
	locationCd2: '',
	purQty: 0,
	packQty: 0,
	salQty: 0,
	itemImage: '',
	itemImage2: '',
	customCd: '',
	customNm: '',
	customItemcd: '',
	equipmentCd: '',
	equipmentNm: '',
	prodStockType: 'I',
	inspectYn: 'Y',
	remark: '',

	inserted: false,
	isModified: false
}


//작업표준 등록 상세 - 작업표준
export interface MST3020_R01DetailDto extends TqcWorkStandardDto{

	itemNm: string;
	itemSpec: string;
	dcAmt: number;

}

export const defaultMST3020_R01DetailDto: MST3020_R01DetailDto = {
	valueIndex: 0,
	orderIndex: 0,
	orderIndexSeq: 0,

	itemCd: "",
	workplaceCd: "",
	workplaceNm: "",
	workplaceSeq: 1,
	cycletime: 0,
	cavity: 0,
	boxQty: 0,
	standardSheet: "",
	standardSheet2: "",
	warehouseCd: "",
	warehouseNm: "",
	remark: "",

	itemNm: "",
	itemSpec: "",
	dcAmt: 0,

	inserted: false,
	isModified: false,
}
